export function isPreviewMeasurementHost(hostname: string): boolean {
  const host = hostname.toLowerCase();

  if (!host) return true;
  if (host === 'localhost' || host === '127.0.0.1' || host.endsWith('.localhost')) return true;
  if (host.endsWith('.lovableproject.com')) return true;

  return host.endsWith('.lovable.app') && host.includes('--');
}

export function shouldSkipPublicMeasurement(hostname: string): boolean {
  return isPreviewMeasurementHost(hostname);
}